export default __webpack_public_path__ + "media/images/react_icons/property/sauna-67a9e06599a90657e5ba94486aa65e3e.svg";